/* Standard PDP v1 (non-ARTG products). Based on tapex-v5.js: pack rows, one-time / subscribe,
   price per serve, optional add-on toggle, sticky bar, mobile carousel, ingredient slider.
   26 Oct 2026: products whose Loop plans don't match the section's plan IDs show the Loop app widget
   instead of the built-in toggle. In that case this script leaves the selling plan to the widget,
   tells it when the pack size changes, and sends whatever plan it picked to the cart. */
(function(){
  var root = document.getElementById('tapex');
  if (!root) return;
  var box = root.querySelector('.tx-buybox');
  if (!box) return;
  var $ = function(id){ return document.getElementById(id); };
  var rows = Array.prototype.slice.call(root.querySelectorAll('.tx-row'));
  var moreBtn = $('tx-more'), addon = $('tx-upsell'), addonPrice = $('tx-upsell-price');
  var variantInput = $('tx-variant'), planInput = $('tx-plan'), atc = $('tx-atc'), qtyInput = $('tx-qty'), form = $('tx-form');
  var stickyBar = $('tx-sticky'), stickyCta = $('tx-sticky-cta'), stickySize = $('tx-sticky-size'), stickyTitle = $('tx-sticky-title');
  var shipLine = $('tx-ship-line'), billLine = $('tx-bill-line');
  var shipBase = shipLine ? shipLine.textContent : '';
  var modeBtns = root.querySelectorAll('[data-mode]');
  var BUILTIN_SUB = modeBtns.length > 0;
  var FREE_SUB = parseInt(box.getAttribute('data-ship-free-sub'),10) || 7500;
  var SUB_FEE = box.getAttribute('data-ship-sub-fee') || '';
  var NAME = box.getAttribute('data-name') || '';
  var CTA = box.getAttribute('data-cta') || 'Add to Cart';
  var ADDON_ID = addon ? addon.getAttribute('data-addon-id') : '';
  var ADDON_PRICE = addon ? (parseInt(addon.getAttribute('data-addon-price'),10) || 0) : 0;
  var mode = 'once', addonOn = false, expanded = false;
  var QTY_MIN = 1, QTY_MAX = 10;
  var CUR = box.getAttribute('data-cur') || '$';
  var money = function(c){ return CUR + (c/100).toFixed(2); };
  var short = function(c){ var s=(c/100).toFixed(2); return CUR + (s.slice(-3)==='.00' ? s.slice(0,-3) : s); };
  var num = function(el,a){ return parseInt(el.getAttribute(a),10) || 0; };
  var D = '·';

  function selected(){ for (var i=0;i<rows.length;i++){ if(rows[i].classList.contains('selected')) return rows[i]; } return rows[0]; }
  function qty(){ var v=parseInt(qtyInput.value,10); if(isNaN(v)||v<QTY_MIN) v=QTY_MIN; if(v>QTY_MAX) v=QTY_MAX; return v; }
  function available(r){ return mode === 'once' || num(r,'data-sub') > 0; }
  function priceOf(r){ return num(r, mode === 'sub' ? 'data-sub' : 'data-price'); }
  function fullOf(r){ return num(r, mode === 'sub' ? 'data-price' : 'data-full'); }
  function every(n){ return n === 1 ? 'every month' : (n === 12 ? 'every 12 months' : 'every ' + n + ' months'); }

  function notifyVariant(id){
    if (BUILTIN_SUB) return;
    try {
      variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('variant:change', { detail: { variantId: id } }));
      if (window.history && window.history.replaceState){ var u = new URL(window.location.href); u.searchParams.set('variant', id); window.history.replaceState({}, '', u.toString()); }
    } catch(e){}
  }

  function widgetPlan(){
    if (planInput.value) return planInput.value;
    var els = form.querySelectorAll('[name="selling_plan"]');
    for (var i=0;i<els.length;i++){
      var el = els[i];
      if (el === planInput || el.disabled) continue;
      if ((el.type === 'radio' || el.type === 'checkbox') && !el.checked) continue;
      if (el.value) return el.value;
    }
    return '';
  }

  function layout(){
    var sel = selected();
    rows.forEach(function(r){
      var hide = !available(r) || (r.classList.contains('tx-extra') && !expanded && r !== sel);
      r.classList.toggle('tx-hidden', hide);
    });
    if (moreBtn){
      var extras = rows.filter(function(r){ return r.classList.contains('tx-extra') && available(r); });
      moreBtn.classList.toggle('tx-hidden', extras.length === 0);
      moreBtn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      moreBtn.querySelector('span').textContent = expanded ? 'Fewer options' : 'More options';
    }
  }

  function render(){
    var sel = selected(); if (!sel) return;
    if (!available(sel)){ var fb = rows.filter(available)[0]; if (fb){ rows.forEach(function(x){ x.classList.remove('selected'); }); fb.classList.add('selected'); sel = fb; } }
    rows.forEach(function(r){
      var n = num(r,'data-size'), sv = num(r,'data-serves') || 1;
      var price = priceOf(r), full = fullOf(r), save = full > price ? full - price : 0;
      var sub = r.querySelector('.tx-row-sub'), ship = r.querySelector('.tx-row-ship');
      if (mode === 'sub'){
        sub.textContent = (n === 12 ? 'Delivered once a year' : 'Delivered ' + every(n)) + (num(r,'data-off') ? ' ' + D + ' ' + num(r,'data-off') + '% off' : '');
        if (SUB_FEE){ ship.textContent = price >= FREE_SUB ? 'Free shipping' : ('Shipping ' + SUB_FEE); ship.classList.remove('tx-hidden'); } else { ship.classList.add('tx-hidden'); }
      } else {
        sub.textContent = sv + ' serves';
        ship.classList.add('tx-hidden');
      }
      r.querySelector('[data-now]').textContent = money(price);
      r.querySelector('[data-perday]').textContent = money(price/sv) + '/serve';
      var strike = r.querySelector('[data-strike]');
      if (save > 0){ strike.textContent = money(full); strike.style.display = ''; } else { strike.style.display = 'none'; }
      var banner = r.querySelector('.tx-row-banner');
      if (banner){ var lead = n === 12 ? 'Best value' : 'Most popular'; banner.textContent = save > 0 ? (lead + ' ' + D + ' Save ' + short(save)) : lead; }
    });
    layout();
    var unit = priceOf(sel), n = num(sel,'data-size');
    var newId = sel.getAttribute('data-id');
    var changed = variantInput.value !== newId;
    variantInput.value = newId;
    if (BUILTIN_SUB) planInput.value = mode === 'sub' ? (sel.getAttribute('data-plan') || '') : '';
    if (changed) notifyVariant(newId);
    var total = money(unit*qty() + (addonOn ? ADDON_PRICE : 0));
    var label = (mode === 'sub' ? 'Subscribe ' : CTA + ' ') + D + ' ' + total;
    atc.textContent = label;
    if (stickyCta) stickyCta.textContent = label;
    if (stickyTitle) stickyTitle.textContent = NAME + (mode === 'sub' ? ' ' + D + ' Subscribe' : '');
    if (stickySize){
      Array.prototype.forEach.call(stickySize.options, function(o){ var r = rows.filter(function(x){ return x.getAttribute('data-size') === o.value; })[0]; o.disabled = !r || !available(r); });
      stickySize.value = sel.getAttribute('data-size');
    }
    if (billLine) billLine.textContent = mode === 'sub' ? ('Charged ' + money(unit*qty()) + ' ' + every(n) + '. Pause or cancel anytime.') : '100% money-back guarantee';
    if (shipLine) shipLine.textContent = mode === 'sub' ? 'Your first delivery ships now. Later deliveries follow your schedule.' : shipBase;
    if (addon && addonPrice){
      addon.classList.toggle('on', addonOn);
      addon.setAttribute('aria-pressed', addonOn ? 'true' : 'false');
      addonPrice.textContent = (addonOn ? 'Added ' + D + ' ' + money(ADDON_PRICE) : '+' + money(ADDON_PRICE)) + ' ' + D + ' one-time purchase';
    }
  }

  function selectSize(size){ rows.forEach(function(x){ x.classList.toggle('selected', x.getAttribute('data-size') === String(size)); }); render(); }
  rows.forEach(function(r){ r.addEventListener('click', function(){ selectSize(r.getAttribute('data-size')); }); });
  if (moreBtn) moreBtn.addEventListener('click', function(){ expanded = !expanded; layout(); });
  if (addon) addon.addEventListener('click', function(){ addonOn = !addonOn; render(); });

  function setMode(m){
    mode = m;
    modeBtns.forEach(function(b){ var on = b.getAttribute('data-mode') === m; b.classList.toggle('active', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
    render();
  }
  modeBtns.forEach(function(b){ b.addEventListener('click', function(){ setMode(b.getAttribute('data-mode')); }); });

  $('tx-qty-minus').addEventListener('click', function(){ qtyInput.value = Math.max(QTY_MIN, qty()-1); render(); });
  $('tx-qty-plus').addEventListener('click', function(){ qtyInput.value = Math.min(QTY_MAX, qty()+1); render(); });
  qtyInput.addEventListener('change', function(){ qtyInput.value = qty(); render(); });
  qtyInput.addEventListener('input', render);

  function scrollToBuy(){ form.scrollIntoView({behavior:'smooth', block:'center'}); }
  var finalCta = $('tx-final-cta');
  if (finalCta) finalCta.addEventListener('click', scrollToBuy);
  if (stickySize) stickySize.addEventListener('change', function(){ selectSize(stickySize.value); });
  if (stickyCta) stickyCta.addEventListener('click', function(){ if (form.requestSubmit) form.requestSubmit(); else atc.click(); });

  form.addEventListener('submit', function(e){
    e.preventDefault();
    atc.disabled = true;
    var main = { id: parseInt(variantInput.value,10), quantity: qty() };
    var plan = BUILTIN_SUB ? planInput.value : widgetPlan();
    if (plan) main.selling_plan = parseInt(plan,10);
    var items = [main];
    if (addonOn && ADDON_ID) items.push({ id: parseInt(ADDON_ID,10), quantity: 1 });
    fetch('/cart/add.js', { method:'POST', body: JSON.stringify({ items: items }), headers: {'Content-Type':'application/json','Accept':'application/json'} })
      .then(function(r){ return r.json(); })
      .then(function(data){
        atc.disabled = false;
        if (data.status){ alert('Could not add to cart: ' + (data.description || data.message || 'please try again.')); return; }
        if (window.Shopify && typeof window.Shopify.onItemAdded === 'function'){ window.Shopify.onItemAdded(data, true); }
        else { window.location.href = '/cart'; }
      })
      .catch(function(err){ atc.disabled = false; console.error('add to cart failed', err); if (!plan) planInput.disabled = true; else planInput.value = plan; form.submit(); });
  });

  if (stickyBar && stickyCta && 'IntersectionObserver' in window){
    var shown = false;
    new IntersectionObserver(function(entries){
      var e = entries[0], past = !e.isIntersecting && e.boundingClientRect.top < 0;
      if (past !== shown){
        shown = past;
        stickyBar.classList.toggle('show', past);
        stickyBar.setAttribute('aria-hidden', past ? 'false' : 'true');
        stickyCta.tabIndex = past ? 0 : -1;
        if (stickySize) stickySize.tabIndex = past ? 0 : -1;
      }
    }).observe(atc);
  }

  var main = $('tx-car-main'), wrap = $('tx-car-wrap');
  var thumbs = root.querySelectorAll('.tx-car-thumb'), dots = root.querySelectorAll('#tx-car-dots i');
  function cur(){ for (var i=0;i<thumbs.length;i++){ if(thumbs[i].classList.contains('active')) return i; } return 0; }
  function show(i){
    if (!thumbs.length || !main) return;
    if (i<0) i=thumbs.length-1; if (i>=thumbs.length) i=0;
    thumbs.forEach(function(t,k){ t.classList.toggle('active', k===i); });
    dots.forEach(function(d,k){ d.classList.toggle('on', k===i); });
    main.src = thumbs[i].getAttribute('data-src');
  }
  thumbs.forEach(function(t,i){ t.addEventListener('click', function(){ show(i); }); });
  var prev = $('tx-car-prev'), next = $('tx-car-next');
  if (prev) prev.addEventListener('click', function(){ show(cur()-1); });
  if (next) next.addEventListener('click', function(){ show(cur()+1); });
  if (wrap){
    var sx = null;
    wrap.addEventListener('touchstart', function(e){ sx = e.touches[0].clientX; }, {passive:true});
    wrap.addEventListener('touchend', function(e){ if (sx === null) return; var dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 40) show(cur() + (dx < 0 ? 1 : -1)); sx = null; });
  }

  var track = $('tx-ing-track');
  function slide(dir){ if (track) track.scrollBy({left: dir * track.clientWidth * 0.82, behavior:'smooth'}); }
  var ip = $('tx-ing-prev'), inx = $('tx-ing-next');
  if (ip) ip.addEventListener('click', function(){ slide(-1); });
  if (inx) inx.addEventListener('click', function(){ slide(1); });

  setMode('once');
})();